import React, { Component } from 'react';
import { array, bool, func, oneOf, object, shape, string, arrayOf } from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useHistory, useLocation } from 'react-router-dom';
import omit from 'lodash/omit';
import classNames from 'classnames';

import { useIntl, intlShape, FormattedMessage } from '../../util/reactIntl';
import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { withCookies } from 'react-cookie';
import { createResourceLocatorString } from '../../util/routes';
import {
  isAnyFilterActive,
  isMainSearchTypeKeywords,
  getQueryParamNames,
  isOriginInUse,
} from '../../util/search';
import { parse } from '../../util/urlHelpers';
import { propTypes } from '../../util/types';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/ui.duck';
import { trackEvent } from '../../util/analytics';

import { H3, H5, OfferBar, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

import {
  groupListingFieldConfigs,
  initialValues,
  searchParamsPicker,
  validUrlQueryParamsFromProps,
  validFilterParams,
  cleanSearchFromConflictingParams,
  createSearchResultSchema,
} from './SearchPage.shared';
import { toggleFavorite } from '../../containers/WishlistPage/WishlistPage.actions';

import FilterComponent from './FilterComponent';
import MainPanelHeader from './MainPanelHeader/MainPanelHeader';
import SearchFiltersMobile from './SearchFiltersMobile/SearchFiltersMobile';
import SortBy from './SortBy/SortBy';
import SearchResultsPanel from './SearchResultsPanel/SearchResultsPanel';
import NoSearchResultsMaybe from './NoSearchResultsMaybe/NoSearchResultsMaybe';

import css from './SearchPage.module.css';
import {
  getColorFilter,
  getConditionFilter,
  getListingFields,
  getMaterialFilter,
} from '../../config/configListing';
import {
  getmarketplaceData,
  //  marketplaceData
} from '../../marketplace-data';

const MODAL_BREAKPOINT = 768; // Search is in modal on mobile layout

// SortBy component has its content in dropdown-popup.
// With this offset we move the dropdown a few pixels on desktop layout.
const FILTER_DROPDOWN_OFFSET = -14;

const getLanguageFromCookies = cookies => {
  return cookies?.get?.('language') || cookies?.cookies?.language || 'el';
};

export class SearchPageComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMobileModalOpen: false,
      currentQueryParams: validUrlQueryParamsFromProps(props),
      keyword: '',
      selectedSort: null,
    };
    this.componentRef = React.createRef();
    this.onOpenMobileModal = this.onOpenMobileModal.bind(this);
    this.onCloseMobileModal = this.onCloseMobileModal.bind(this);
    this.defaultOptions = this.defaultOptions.bind(this);
    this.productsIfBrand = this.productsIfBrand.bind(this);
    this.subCategoriesIfBrand = this.subCategoriesIfBrand.bind(this);
    // Filter functions
    this.resetAll = this.resetAll.bind(this);
    this.getHandleChangedValueFn = this.getHandleChangedValueFn.bind(this);
    this.handleRemoveOneFilter = this.handleRemoveOneFilter.bind(this);
    // SortBy
    this.handleSortBy = this.handleSortBy.bind(this);
    this.handleKeyword = this.handleKeyword.bind(this);
  }

  getSearchRouteParams(extraParams = {}) {
    const { routePageName = 'SearchPage', routePagePathParams = {}, history } = this.props;
    const location = history.location;
    const pathname = location?.pathname;
    const showAll = pathname.includes('all_products');
    const searchPageParams =
      routePageName === 'SearchPage' && showAll ? { searchTerm: 'all_products' } : {};

    return {
      pageName: routePageName,
      pathParams: {
        ...routePagePathParams,
        ...searchPageParams,
        ...extraParams,
      },
    };
  }

  // Invoked when a modal is opened from a child component,
  // for example when a filter modal is opened in mobile view
  onOpenMobileModal(state) {
    const { history, routeConfiguration } = this.props;
    const urlQueryParams = validUrlQueryParamsFromProps(this.props);
    const searchParams = { ...urlQueryParams, showFilters: state };
    const { pageName, pathParams } = this.getSearchRouteParams();
    history.push(
      createResourceLocatorString(pageName, routeConfiguration, pathParams, searchParams)
    );
    // this.setState({ isMobileModalOpen: true });
  }

  // Invoked when a modal is closed from a child component,
  // for example when a filter modal is opened in mobile view
  onCloseMobileModal() {
    this.setState({ isMobileModalOpen: false });
  }

  // Reset all filter query parameters
  resetAll(e) {
    const { history, routeConfiguration, config, routePageName = 'SearchPage' } = this.props;
    const { listingFields: listingFieldsConfig } = config?.listing || {};
    const { defaultFilters: defaultFiltersConfig } = config?.search || {};
    const location = history.location;
    const pathname = location?.pathname;
    const showAll = pathname.includes('all_products');
    const urlQueryParams = validUrlQueryParamsFromProps(this.props);
    const filterQueryParamNames = getQueryParamNames(
      listingFieldsConfig,
      defaultFiltersConfig
    ).filter(paramName => paramName !== 'keywords');
    const marketplaceFilterQueryParamNames = [
      'pub_category',
      'pub_subCategory',
      'pub_designer',
      'pub_colour',
      'pub_color',
      'pub_size',
      'pub_condition',
      'pub_material',
      'price',
    ];
    const resetFilterQueryParamNames = [
      ...new Set([...filterQueryParamNames, ...marketplaceFilterQueryParamNames]),
    ];
    // Reset state
    this.setState({ currentQueryParams: {} });

    const isFromSearch =
      urlQueryParams?.fromSearch === true || urlQueryParams?.fromSearch === 'true';
    const isSearchBarSearch = !!urlQueryParams?.keywords || isFromSearch;
    const isCampaignSearchPage = routePageName !== 'SearchPage';
    const isMegaMenu = !showAll && !isSearchBarSearch && !isCampaignSearchPage;

    // Reset routing params
    const queryParams = omit(urlQueryParams, resetFilterQueryParamNames);
    const queryParamsOnlyCategory = isMegaMenu
      ? {
          pub_department: urlQueryParams.pub_department,
          pub_category: urlQueryParams.pub_category,
        }
      : queryParams;
    const { pageName, pathParams } = this.getSearchRouteParams();
    history.push(
      createResourceLocatorString(pageName, routeConfiguration, pathParams, queryParamsOnlyCategory)
    );
  }
  handleKeyword(e) {
    this.setState({ keyword: e.target.value });
  }
  getHandleChangedValueFn(useHistoryPush) {
    const { history, routeConfiguration, config, cookies } = this.props;
    const languageInCookie = getLanguageFromCookies(cookies);

    const marketplaceData = getmarketplaceData(languageInCookie);
    const location = history.location;
    const pathname = location?.pathname;
    const showAll = pathname.includes('all_products');
    const { listingFields: listingFieldsConfig } = config?.listing || {};
    const { defaultFilters: defaultFiltersConfig, sortConfig } = config?.search || {};
    const filterData = marketplaceData;
    const urlQueryParams = validUrlQueryParamsFromProps(this.props);

    const category = urlQueryParams?.pub_department || 'women';
    const isCategoryKids = category === 'kids';
    const isSubCategorySelected = urlQueryParams?.pub_category;
    const selectedProduct = urlQueryParams?.pub_subCategory;

    const isBrandSelected = urlQueryParams?.pub_designer;
    const mainFilter = filterData?.find(d => d.value === category);
    let genderFilter = isCategoryKids ? mainFilter?.gender : null;
    const isGenderFilterActive = urlQueryParams?.pub_gender;
    const allGenderSubCategories = genderFilter?.enumOptions?.map(d => d.subCategories);
    const defaultSubCategoryFilterOptions = isCategoryKids
      ? this.defaultOptions(allGenderSubCategories)
      : null;
    let subCategoryFilter = isGenderFilterActive
      ? genderFilter?.enumOptions?.find(d => d.value === urlQueryParams?.pub_gender)?.subCategories
      : mainFilter?.subCategories || defaultSubCategoryFilterOptions;

    const finalSubCategoryFilter = isBrandSelected
      ? this.subCategoriesIfBrand(subCategoryFilter)
      : subCategoryFilter;
    const allProducts = subCategoryFilter?.enumOptions?.map(d => d.products);

    const defaultProductFilterOptions = this.defaultOptions(allProducts);
    let productFilter = isBrandSelected
      ? this.productsIfBrand(defaultProductFilterOptions, subCategoryFilter)
      : urlQueryParams?.pub_category
      ? subCategoryFilter?.enumOptions?.find(d => d.value === urlQueryParams?.pub_category)
          ?.products
      : defaultProductFilterOptions;

    const isSubcategoryChanged = selectedProduct
      ? productFilter?.enumOptions || []?.find(d => d.value === selectedProduct)
        ? selectedProduct
        : null
      : null;

    return updatedURLParams => {
      const updater = prevState => {
        const { address, bounds, keywords } = urlQueryParams;
        // const mergedQueryParams = { ...urlQueryParams, ...prevState.currentQueryParams };
        let mergedQueryParams = {
          ...urlQueryParams,
          ...prevState.currentQueryParams,
          pub_department: urlQueryParams.pub_department,
          pub_category: urlQueryParams.pub_category,
          pub_subCategory: urlQueryParams.pub_subCategory,
          pub_designer: urlQueryParams.pub_designer,
        };
        if (
          updatedURLParams.hasOwnProperty('pub_department') &&
          prevState.currentQueryParams['pub_department'] != updatedURLParams['pub_department']
        ) {
          // Preserve colour, price, and condition when department changes
          mergedQueryParams = {
            pub_colour: prevState.currentQueryParams.pub_colour,
            price: prevState.currentQueryParams.price,
            pub_condition: prevState.currentQueryParams.pub_condition,
          };
        }
        if (
          updatedURLParams.hasOwnProperty('pub_category') &&
          prevState.currentQueryParams['pub_category'] != updatedURLParams['pub_category']
        ) {
          mergedQueryParams = {
            ...mergedQueryParams,
            pub_subCategory: null,
            pub_size: null,
            pub_material: null,
          };
        }
        if (
          updatedURLParams.hasOwnProperty('pub_designer') &&
          prevState.currentQueryParams['pub_designer'] != updatedURLParams['pub_designer']
        ) {
          this.setState({ keyword: '' });
          mergedQueryParams = {
            ...mergedQueryParams,
            pub_category: isSubCategorySelected
              ? finalSubCategoryFilter?.enumOptions ||
                []?.find(d => d.value === isSubCategorySelected)
                ? isSubCategorySelected
                : null
              : null,
            // pub_subCategory: selectedProduct
            //   ? productFilter?.enumOptions || []?.find(d => d.value === selectedProduct)
            //     ? selectedProduct
            //     : null
            //   : null,
            pub_subCategory: isSubcategoryChanged,
            // pub_category: null,
            pub_size: null,
            pub_material: null,
          };
        }
        if (
          updatedURLParams.hasOwnProperty('pub_subCategory') &&
          prevState.currentQueryParams['pub_subCategory'] != updatedURLParams['pub_subCategory']
        ) {
          mergedQueryParams = {
            ...mergedQueryParams,
            pub_size: null,
            pub_material: null,
          };
        }
        // Address and bounds are handled outside of MainPanel.
        // I.e. TopbarSearchForm && search by moving the map.
        // We should always trust urlQueryParams with those.
        // The same applies to keywords, if the main search type is keyword search.
        const keywordsMaybe = isMainSearchTypeKeywords(config) ? { keywords } : {};
        return {
          currentQueryParams: {
            ...mergedQueryParams,
            ...updatedURLParams,
            ...keywordsMaybe,
            address,
            bounds,
          },
        };
      };

      const callback = () => {
        if (useHistoryPush) {
          const searchParams = this.state.currentQueryParams;
          const search = cleanSearchFromConflictingParams(
            searchParams,
            listingFieldsConfig,
            defaultFiltersConfig,
            sortConfig
          );
          const { pageName, pathParams } = this.getSearchRouteParams();
          history.push(
            createResourceLocatorString(pageName, routeConfiguration, pathParams, search)
          );
        }
      };

      this.setState(updater, callback);
    };
  }
  componentDidMount() {
    const { history, routeConfiguration, shouldDefaultDepartmentToWomen = true } = this.props;

    const urlQueryParams = validUrlQueryParamsFromProps(this.props);
    const department = urlQueryParams?.pub_department;
    if (shouldDefaultDepartmentToWomen && !department) {
      const queryParams = { ...urlQueryParams, pub_department: 'women' };
      const { pageName, pathParams } = this.getSearchRouteParams({ searchTerm: 'all_products' });
      history.push(
        createResourceLocatorString(pageName, routeConfiguration, pathParams, queryParams)
      );
    }
  }
  // componentDidUpdate(prevProps) {
  //   // Check if the `listings` prop has changed
  //   if (prevProps.listings !== this.props.listings) {
  //     if (this.componentRef.current) {
  //       this.componentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //     }
  //   }
  // }
  componentDidUpdate(prevProps) {
    const { history, searchInProgress, listings, config } = this.props;
    const location = history.location;
    const pathname = location?.pathname;
    const showAll = pathname.includes('all_products');
    const urlQueryParams = validUrlQueryParamsFromProps(this.props);

    const isCategoryChanged = urlQueryParams?.pub_category !== prevProps.searchParams?.pub_category;
    if (this.props.location.search !== prevProps.location.search) {
      const sortFromURL = parse(this.props.location.search)?.sort || null;
      this.setState({ keyword: '', selectedSort: sortFromURL });
    }
    if (this.componentRef.current && isCategoryChanged && !showAll) {
      const container = this.componentRef.current;
      container.scrollTop = 0; // Scroll to the top
    }

    // After login redirect: restore scroll position when search results finish loading
    if (prevProps.searchInProgress && !searchInProgress) {
      const savedScrollY = sessionStorage.getItem('wishlistScrollY');
      if (savedScrollY) {
        sessionStorage.removeItem('wishlistScrollY');
        // Small delay to ensure listings are rendered in the DOM
        setTimeout(() => {
          window.scrollTo(0, parseInt(savedScrollY, 10));
        }, 100);
      }
    }

    // Remarketing: track search results / category listing
    if (prevProps.searchInProgress && !searchInProgress && listings.length > 0) {
      // Google: product list view should use view_item_list
      trackEvent('view_item_list', {
        item_list_id: 'search_results',
        item_list_name: 'Search Results',
        items: listings.map((listing, index) => ({
          item_id: listing.id.uuid,
          id: listing.id.uuid,
          item_name: listing.attributes.title,
          index: index + 1,
          price: listing.attributes.price ? listing.attributes.price.amount / 100 : 0,
          item_category: listing.attributes.publicData?.category,
          item_brand: listing.attributes.publicData?.designer,
        })),
      });

      // Facebook: Search (if keywords present)
      if (urlQueryParams && urlQueryParams.keywords) {
        trackEvent('search', {
          search_string: urlQueryParams.keywords,
          content_type: 'product',
          content_ids: listings.slice(0, 10).map(l => l.id.uuid),
        });
      }
    }
  }
  productsIfBrand(options, subCategoryFilter) {
    const urlQueryParams = validUrlQueryParamsFromProps(this.props);
    const brand = urlQueryParams?.pub_designer;
    const subCategory = urlQueryParams?.pub_category;

    function filterProductsByBrand(products, brandName) {
      return products.filter(product =>
        product.brands?.enumOptions?.some(brand => brand?.value === brandName)
      );
    }
    if (subCategory) {
      const newOptions = subCategoryFilter?.enumOptions?.find(d => d.value === subCategory)
        ?.products;
      newOptions.enumOptions = filterProductsByBrand(newOptions?.enumOptions, brand);
      return newOptions;
    }

    options.enumOptions = filterProductsByBrand(options?.enumOptions, brand);

    return options;
  }
  subCategoriesIfBrand(options) {
    const urlQueryParams = validUrlQueryParamsFromProps(this.props);
    const brand = urlQueryParams?.pub_designer;

    function filterProductsByBrand(products, brandName) {
      return products.filter(product =>
        product.brands?.enumOptions.some(brand => brand.value === brandName)
      );
    }
    function filterSubcategoryByBrand(subCategory, brandName) {
      return subCategory.map(d => {
        const products = d.products;
        const filteredProducts = filterProductsByBrand(products?.enumOptions, brandName);
        if (filteredProducts.length > 0) {
          return {
            ...d,
            products: {
              ...products,
              enumOptions: filteredProducts,
            },
          };
        } else {
          return null;
        }
      });
    }
    const newOptions = filterSubcategoryByBrand(options.enumOptions, brand)?.filter(
      d => d !== null
    );
    const data = {
      ...options,
      enumOptions: newOptions,
    };

    return data;
  }
  defaultOptions(options, category) {
    if (!options) return [];
    const mergedEnumOptions = options?.reduce((acc, curr) => {
      curr.enumOptions.forEach(d => {
        if (!acc.find(e => e.value === d.value && e.show)) {
          acc.push(d);
        }
      });
      return acc;
    }, []);
    const mergedObject = {
      filterConfig: options[0]?.filterConfig,
      key: options[0]?.key,
      schemaType: options[0]?.schemaType,
      scope: options[0]?.scope,
      enumOptions: mergedEnumOptions,
    };

    return mergedObject;
  }
  handleSortBy(urlParam, values) {
    const { history, routeConfiguration } = this.props;
    const urlQueryParams = validUrlQueryParamsFromProps(this.props);
    const queryParams = values
      ? { ...urlQueryParams, [urlParam]: values }
      : omit(urlQueryParams, urlParam);
    const { pageName, pathParams } = this.getSearchRouteParams();
    this.setState({ selectedSort: values || null }, () => {
      history.push(
        createResourceLocatorString(pageName, routeConfiguration, pathParams, queryParams)
      );
    });
  }
  handleRemoveOneFilter = (key, value) => {
    const { history, routeConfiguration } = this.props;
    const urlQueryParams = validUrlQueryParamsFromProps(this.props);

    const values = urlQueryParams[key]
      .split(',')
      .filter(v => v !== value)
      .join(',');
    let queryParams = values ? { ...urlQueryParams, [key]: values } : omit(urlQueryParams, key);
    if (key === 'pub_category') {
      queryParams = {
        ...queryParams,
        pub_subCategory: null,
        pub_size: null,
        pub_material: null,
      };
    }
    if (key === 'pub_designer') {
      queryParams = {
        ...queryParams,
        pub_subCategory: null,
        pub_size: null,
        pub_material: null,
      };
    }
    if (key === 'pub_subCategory') {
      queryParams = {
        ...queryParams,
        pub_size: null,
        pub_material: null,
      };
    }
    if (key === 'pub_department') {
      queryParams = {
        ...queryParams,
        pub_category: null,
        pub_subCategory: null,
        pub_size: null,
        pub_material: null,
      };
    }
    if (key === 'price') {
      queryParams = {
        ...queryParams,
        price: null,
      };
    }

    this.setState({ currentQueryParams: queryParams });
    const { pageName, pathParams } = this.getSearchRouteParams();
    history.push(
      createResourceLocatorString(pageName, routeConfiguration, pathParams, queryParams)
    );
  };
  // Reset all filter query parameters
  handleResetAll(e) {
    this.resetAll(e);

    // blur event target if event is passed
    if (e && e.currentTarget) {
      e.currentTarget.blur();
    }
  }

  render() {
    const {
      intl,
      listings,
      location,
      onManageDisableScrolling,
      pagination,
      scrollingDisabled,
      searchInProgress,
      searchListingsError,
      searchParams,
      routeConfiguration,
      config,
      cookies,
      currentUser,
      onToggleFavorite,
      toggleFavoriteListingId,
      facetCounts,
      routePageName = 'SearchPage',
      routePagePathParams = {},
      campaignPageTitle = null,
      salePriceByListingId = null,
      additionalSortOptions = [],
      defaultSort = null,
    } = this.props;

    const favorites = currentUser?.attributes?.profile?.publicData?.favorites || [];

    const languageInCookie = getLanguageFromCookies(cookies);
    const marketplaceData = getmarketplaceData(languageInCookie);
    const conditionFilter = getConditionFilter(languageInCookie);
    const materialFilter = getMaterialFilter(languageInCookie);
    const colorFilter = getColorFilter(languageInCookie);
    const listingFields = getListingFields(languageInCookie);
    const filterData = marketplaceData;
    const { listingFields: listingFieldsConfig } = config?.listing || {};
    const { defaultFilters: defaultFiltersConfig, sortConfig } = config?.search || {};
    const defaultSortOption = defaultSort ? { key: defaultSort, label: defaultSort } : null;
    const pageSortConfig = defaultSortOption
      ? {
          ...sortConfig,
          options: [
            defaultSortOption,
            ...(sortConfig.options || []).filter(option => option.key !== defaultSort),
          ],
        }
      : sortConfig;
    const activeListingTypes = config?.listing?.listingTypes.map(config => config.listingType);
    const marketplaceCurrency = config.currency;
    // Page transition might initially use values from previous search
    // urlQueryParams doesn't contain page specific url params
    // like mapSearch, page or origin (origin depends on config.maps.search.sortSearchByDistance)
    const { searchParamsAreInSync, urlQueryParams, searchParamsInURL } = searchParamsPicker(
      location.search,
      searchParams,
      listingFieldsConfig,
      defaultFiltersConfig,
      pageSortConfig,
      isOriginInUse(config)
    );
    const showFilterInMobile = searchParams?.showFilters;
    const localUrlQueryParams = validUrlQueryParamsFromProps(this.props);
    const validQueryParams = { ...urlQueryParams, ...localUrlQueryParams };
    const isCampaignSearchPage = routePageName !== 'SearchPage';

    // aarsh
    const category = validQueryParams?.pub_department || 'women';
    const isCategoryKids = category === 'kids';
    const isSubCategorySelected = validQueryParams?.pub_category;
    const isBrandSelected = validQueryParams?.pub_designer;
    const mainFilter = filterData?.find(d => d.value === category);
    let genderFilter = isCategoryKids ? mainFilter?.gender : null;
    const isGenderFilterActive = validQueryParams?.pub_gender;
    const allGenderSubCategories = genderFilter?.enumOptions?.map(d => d.subCategories);
    const defaultSubCategoryFilterOptions = isCategoryKids
      ? this.defaultOptions(allGenderSubCategories)
      : null;
    let subCategoryFilter = isGenderFilterActive
      ? genderFilter?.enumOptions?.find(d => d.value === validQueryParams?.pub_gender)
          ?.subCategories
      : mainFilter?.subCategories || defaultSubCategoryFilterOptions;

    const finalSubCategoryFilter = isBrandSelected
      ? this.subCategoriesIfBrand(subCategoryFilter)
      : subCategoryFilter;

    // aarsh

    const allProducts = subCategoryFilter?.enumOptions?.map(d => d.products);

    const defaultProductFilterOptions = this.defaultOptions(allProducts);

    let productFilter = isBrandSelected
      ? this.productsIfBrand(defaultProductFilterOptions, subCategoryFilter)
      : validQueryParams?.pub_category
      ? subCategoryFilter?.enumOptions?.find(d => d.value === validQueryParams?.pub_category)
          ?.products
      : defaultProductFilterOptions;

    const allBrandsAfterProductFilter = productFilter?.enumOptions?.map(d => d.brands) || [];
    // console.log('allBrandsAfterProductFilter', allBrandsAfterProductFilter);
    const allSizes = productFilter?.enumOptions?.map(d => d.sizes)?.filter(d => d);
    const defaultSizeFilterOptions = this.defaultOptions(allSizes);
    let sizeFilter = validQueryParams?.pub_subCategory
      ? productFilter?.enumOptions?.find(d => d.value === validQueryParams?.pub_subCategory)
          ?.sizes || null
      : defaultSizeFilterOptions;

    const allBrands = this.defaultOptions(allProducts)?.enumOptions?.map(d => d.brands);
    const defaultBrandFilterOptions = validQueryParams?.pub_category
      ? this.defaultOptions(allBrandsAfterProductFilter)
      : this.defaultOptions(allBrands);
    let brandFilter = validQueryParams?.pub_subCategory
      ? productFilter?.enumOptions?.find(d => d.value === validQueryParams?.pub_subCategory)?.brands
      : defaultBrandFilterOptions;
    const isKeywordSearch = isMainSearchTypeKeywords(config);
    const defaultFilters = isKeywordSearch
      ? defaultFiltersConfig.filter(f => f.key !== 'keywords')
      : defaultFiltersConfig;
    const sellerFilters = defaultFilters.filter(f => f.key === 'seller');
    const defaultFiltersWithoutSeller = defaultFilters.filter(f => f.key !== 'seller');
    const [customPrimaryFilters, customSecondaryFilters] = groupListingFieldConfigs(
      listingFieldsConfig,
      activeListingTypes
    );
    const sortedProductFilter = {
      ...productFilter,
      enumOptions: productFilter?.enumOptions?.sort((a, b) => {
        const locale = intl.locale;
        return a?.label?.localeCompare(b?.label, locale, { sensitivity: 'base' });
      }),
    };

    let sortedBrandFilter = {
      ...brandFilter,
      enumOptions: brandFilter?.enumOptions?.sort((a, b) => {
        const locale = intl.locale;
        return a?.label?.localeCompare(b?.label, locale, { sensitivity: 'base' });
      }),
    };
    const otherBrandFilter = sortedBrandFilter?.enumOptions?.filter(d => d.value === 'other');
    const brandFilterWithoutOther = sortedBrandFilter?.enumOptions?.filter(
      d => d.value !== 'other'
    );
    if (otherBrandFilter) {
      sortedBrandFilter = {
        ...sortedBrandFilter,
        enumOptions: [...brandFilterWithoutOther, ...otherBrandFilter],
      };
    }
    // console.log('sortedBrandFilter', sortedBrandFilter);
    const subcategoryFilters = isSubCategorySelected ? [sortedProductFilter] : [];
    let availableFilters;
    if (isCategoryKids) {
      availableFilters = [
        ...customPrimaryFilters,
        ...customSecondaryFilters,
        ...listingFields,
        finalSubCategoryFilter,
        ...subcategoryFilters,
        // productFilter,
        // brandFilter,
        sortedBrandFilter,
        genderFilter,
        // subCategoryFilter,

        // sizeFilter,

        colorFilter,
        conditionFilter,
        ...defaultFiltersWithoutSeller,
        materialFilter,
      ];
    } else {
      availableFilters = [
        ...customPrimaryFilters,

        ...customSecondaryFilters,
        ...listingFields,
        finalSubCategoryFilter,
        // productFilter,
        ...subcategoryFilters,
        sortedBrandFilter,
        // brandFilter,
        // subCategoryFilter,

        // sizeFilter,

        colorFilter,
        conditionFilter,
        ...defaultFiltersWithoutSeller,
      ];
    }
    if (
      (validQueryParams?.pub_category && validQueryParams?.pub_category !== 'accessories') ||
      validQueryParams?.pub_subCategory
    ) {
      if (sizeFilter) {
        const availableFiltersWithoutPrice = availableFilters.filter(d => d.key !== 'price');
        // console.log('availableFiltersWithoutPrice', availableFiltersWithoutPrice);
        availableFilters = [
          ...availableFiltersWithoutPrice,
          sizeFilter,
          ...defaultFiltersWithoutSeller,
          materialFilter,
        ];
      } else {
        availableFilters = [...availableFilters, materialFilter];
      }
    }

    if (!mainFilter) {
      availableFilters = [];
    }
    if (mainFilter) {
      availableFilters = [...availableFilters.filter(f => f.key !== 'seller'), ...sellerFilters];
    }

    // Selected aka active filters
    const selectedFilters = validFilterParams(
      validQueryParams,
      listingFieldsConfig,
      defaultFiltersConfig
    );

    const isValidDatesFilter =
      searchParamsInURL.dates == null ||
      (searchParamsInURL.dates != null && searchParamsInURL.dates === selectedFilters.dates);
    const keysOfSelectedFilters = Object.keys(selectedFilters);
    const isSelectedFilterLengthGreaterThanOne = keysOfSelectedFilters.length > 1;
    const selectedFiltersCountForMobile = isKeywordSearch
      ? keysOfSelectedFilters.filter(f => f !== 'keywords').length
      : keysOfSelectedFilters.length;

    const hasPaginationInfo = !!pagination && pagination.totalItems != null;
    const totalItems =
      searchParamsAreInSync && hasPaginationInfo
        ? pagination.totalItems
        : pagination?.paginationUnsupported
        ? listings.length
        : 0;
    const listingsAreLoaded =
      !searchInProgress &&
      searchParamsAreInSync &&
      !!(hasPaginationInfo || pagination?.paginationUnsupported);

    const conflictingFilterActive = isAnyFilterActive(
      sortConfig.conflictingFilters,
      validQueryParams,
      listingFieldsConfig,
      defaultFiltersConfig
    );
    const sortBy = mode => {
      return sortConfig.active ? (
        <SortBy
          sort={this.state.selectedSort || validQueryParams[sortConfig.queryParamName]}
          isConflictingFilterActive={!!conflictingFilterActive}
          hasConflictingFilters={!!(sortConfig.conflictingFilters?.length > 0)}
          selectedFilters={selectedFilters}
          onSelect={this.handleSortBy}
          showAsPopup
          mode={mode}
          additionalOptions={additionalSortOptions}
          defaultSort={defaultSort}
          contentPlacementOffset={FILTER_DROPDOWN_OFFSET}
        />
      ) : null;
    };
    const noResultsInfo = (
      <NoSearchResultsMaybe
        listingsAreLoaded={listingsAreLoaded}
        totalItems={totalItems}
        location={location}
        resetAll={this.resetAll}
      />
    );

    const { schema } = createSearchResultSchema(
      listings,
      searchParamsInURL || {},
      intl,
      routeConfiguration,
      config
    );
    //seo change

    const mainCategory = validQueryParams?.pub_category;
    const subCategory = validQueryParams?.pub_subCategory;
    const designer = validQueryParams?.pub_designer;
    const categoryOptions = mainCategory
      ? availableFilters?.find(filter => filter.key === 'category')
      : null;
    const subCategoryOptions = subCategory
      ? availableFilters?.find(filter => filter.key === 'subCategory')
      : null;
    const designerOptions = designer
      ? availableFilters?.find(filter => filter.key === 'designer')
      : null;
    const categoryLabel = categoryOptions
      ? categoryOptions?.enumOptions?.find(option => option.value === mainCategory)?.label
      : null;
    const subCategoryLabel = subCategoryOptions
      ? subCategoryOptions?.enumOptions?.find(option => option.value === subCategory)?.label
      : null;
    const designerLabel = designerOptions
      ? designerOptions?.enumOptions?.find(option => option.value === designer)?.label
      : null;
    const keywords = validQueryParams?.keywords;
    const searchQuery = keywords ? `${keywords}`.trim() : null;
    const defaultTitle = intl.formatMessage({
      id: 'SearchPage.SearchPageWithGrid.searchPageSeoTitle',
    });

    const optionsKeyword = [keywords].filter(Boolean).join(' - ') || null;
    let options =
      [categoryLabel, subCategoryLabel, designerLabel].filter(Boolean).join(' - ') || null;

    const isSubCategoryAndMore = categoryLabel && (subCategoryLabel || designerLabel);
    if (isSubCategoryAndMore) {
      options = [subCategoryLabel, designerLabel].filter(Boolean).join(' - ') || null;
    }

    const description = intl.formatMessage({
      id: 'SearchPage.SearchPageWithGrid.descriptionSearchpage',
    });
    const searchPageTitle = optionsKeyword
      ? intl.formatMessage(
          { id: 'SearchPage.SearchPageWithGrid.searchPageTitleWhenOptions' },
          { options: optionsKeyword && options ? `${options}-${optionsKeyword}` : optionsKeyword }
        )
      : options
      ? intl.formatMessage(
          { id: 'SearchPage.SearchPageWithGrid.searchPageTitleWhenOptionsNew' },
          { options: `${options}` }
        )
      : defaultTitle;
    const title = campaignPageTitle
      ? `${campaignPageTitle} - ${config.marketplaceName}`
      : searchPageTitle;
    //end of seo change
    // Set topbar class based on if a modal is open in
    // a child component
    const topbarClasses = this.state.isMobileModalOpen
      ? classNames(css.topbarBehindModal, css.topbar)
      : css.topbar;

    // N.B. openMobileMap button is sticky.
    // For some reason, stickyness doesn't work on Safari, if the element is <button>
    return (
      <Page
        scrollingDisabled={scrollingDisabled}
        description={description}
        title={title}
        schema={schema}
      >
        <div className={css.offerbar}>
          <OfferBar />
        </div>
        <TopbarContainer
          rootClassName={topbarClasses}
          currentPage="SearchPage"
          currentSearchParams={urlQueryParams}
          showFilterInMobile={showFilterInMobile}
        />
        <div className={css.root}>
          <div className={css.layoutWrapperContainer}>
            <aside className={css.layoutWrapperFilterColumn} data-testid="filterColumnAside">
              <div className={css.filterColumnContent} ref={this.componentRef}>
                {availableFilters?.map(config => {
                  return (
                    <FilterComponent
                      key={`SearchFiltersMobile.${config?.scope || 'built-in'}.${config.key}`}
                      idPrefix="SearchFiltersMobile"
                      className={css.filter}
                      config={config}
                      marketplaceCurrency={marketplaceCurrency}
                      urlQueryParams={urlQueryParams}
                      initialValues={initialValues(this.props, this.state.currentQueryParams)}
                      getHandleChangedValueFn={this.getHandleChangedValueFn}
                      keyword={this.state.keyword}
                      handleKeyword={this.handleKeyword}
                      intl={intl}
                      languageInCookie={languageInCookie}
                      facetCounts={facetCounts}
                      allowCategoryChange={isCampaignSearchPage}
                      // history={history}
                      liveEdit
                      showAsPopup={false}
                      isDesktop
                    />
                  );
                })}
                {isSelectedFilterLengthGreaterThanOne ? (
                  <button className={css.resetAllButton} onClick={e => this.handleResetAll(e)}>
                    <FormattedMessage id={'SearchFiltersMobile.resetAll'} />
                  </button>
                ) : null}
              </div>
            </aside>

            <div className={css.layoutWrapperMain} role="main">
              <div className={css.searchResultContainer}>
                {campaignPageTitle ? (
                  <h1 className={css.campaignPageTitle}>{campaignPageTitle}</h1>
                ) : null}
                <SearchFiltersMobile
                  className={css.searchFiltersMobileList}
                  urlQueryParams={validQueryParams}
                  sortByComponent={sortBy('mobile')}
                  listingsAreLoaded={listingsAreLoaded}
                  resultsCount={totalItems}
                  searchInProgress={searchInProgress}
                  searchListingsError={searchListingsError}
                  showAsModalMaxWidth={MODAL_BREAKPOINT}
                  onManageDisableScrolling={onManageDisableScrolling}
                  onOpenModal={this.onOpenMobileModal}
                  onCloseModal={this.onCloseMobileModal}
                  resetAll={this.resetAll}
                  selectedFiltersCount={selectedFiltersCountForMobile}
                  isMapVariant={false}
                  noResultsInfo={noResultsInfo}
                  keyword={this.state.keyword}
                  handleKeyword={this.handleKeyword}
                  validQueryParams={validQueryParams}
                  showFilterInMobile={showFilterInMobile}
                  handleRemoveOneFilter={this.handleRemoveOneFilter}
                  availableFilters={availableFilters}
                  searchQuery={searchQuery}
                  allowCategoryRemoval={isCampaignSearchPage}
                >
                  {availableFilters.map(config => {
                    return (
                      <FilterComponent
                        key={`SearchFiltersMobile.${config.scope || 'built-in'}.${config.key}`}
                        idPrefix="SearchFiltersMobile"
                        config={config}
                        marketplaceCurrency={marketplaceCurrency}
                        urlQueryParams={validQueryParams}
                        initialValues={initialValues(this.props, this.state.currentQueryParams)}
                        getHandleChangedValueFn={this.getHandleChangedValueFn}
                        keyword={this.state.keyword}
                        handleKeyword={this.handleKeyword}
                        languageInCookie={languageInCookie}
                        intl={intl}
                        facetCounts={facetCounts}
                        allowCategoryChange={isCampaignSearchPage}
                        liveEdit
                        showAsPopup={false}
                      />
                    );
                  })}
                </SearchFiltersMobile>
                <MainPanelHeader
                  className={css.mainPanel}
                  sortByComponent={sortBy('desktop')}
                  isSortByActive={sortConfig.active}
                  listingsAreLoaded={listingsAreLoaded}
                  resultsCount={totalItems}
                  searchInProgress={searchInProgress}
                  searchListingsError={searchListingsError}
                  noResultsInfo={noResultsInfo}
                  selectedFilters={selectedFilters}
                  validQueryParams={validQueryParams}
                  handleRemoveOneFilter={this.handleRemoveOneFilter}
                  availableFilters={availableFilters}
                  resetAll={this.resetAll}
                  searchQuery={searchQuery}
                  allowCategoryRemoval={isCampaignSearchPage}
                />
                <div
                  className={classNames(css.listingsForGridVariant, {
                    [css.newSearchInProgress]: !(listingsAreLoaded || searchListingsError),
                  })}
                >
                  {searchListingsError ? (
                    <H3 className={css.error}>
                      <FormattedMessage id="SearchPage.searchError" />
                    </H3>
                  ) : null}
                  {!isValidDatesFilter ? (
                    <H5>
                      <FormattedMessage id="SearchPage.invalidDatesFilter" />
                    </H5>
                  ) : null}
                  <SearchResultsPanel
                    className={css.searchListingsPanel}
                    listings={listings}
                    pagination={listingsAreLoaded ? pagination : null}
                    search={parse(location.search)}
                    isMapVariant={false}
                    currentUser={currentUser}
                    favorites={favorites}
                    onToggleFavorite={onToggleFavorite}
                    toggleFavoriteListingId={toggleFavoriteListingId}
                    paginationPageName={routePageName}
                    paginationPagePathParams={routePagePathParams}
                    salePriceByListingId={salePriceByListingId}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <FooterContainer />
      </Page>
    );
  }
}

SearchPageComponent.defaultProps = {
  listings: [],
  pagination: null,
  facetCounts: {},
  searchListingsError: null,
  searchParams: {},
  activeListingId: null,
  currentUser: null,
  toggleFavoriteListingId: null,
  toggleFavoriteError: null,
  onToggleFavorite: () => {},
  routePageName: 'SearchPage',
  routePagePathParams: {},
  searchStateBranch: 'SearchPage',
  shouldDefaultDepartmentToWomen: true,
  campaignPageTitle: null,
  salePriceByListingId: null,
  additionalSortOptions: [],
  defaultSort: null,
};

SearchPageComponent.propTypes = {
  listings: array,
  onManageDisableScrolling: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  onToggleFavorite: func.isRequired,
  currentUser: propTypes.currentUser,
  toggleFavoriteListingId: string,
  toggleFavoriteError: propTypes.error,
  pagination: propTypes.pagination,
  facetCounts: object,
  scrollingDisabled: bool.isRequired,
  searchInProgress: bool.isRequired,
  searchListingsError: propTypes.error,
  searchParams: object,
  routePageName: string,
  routePagePathParams: object,
  searchStateBranch: string,
  shouldDefaultDepartmentToWomen: bool,
  campaignPageTitle: string,
  salePriceByListingId: object,
  additionalSortOptions: array,
  defaultSort: string,

  // from useHistory
  history: shape({
    push: func.isRequired,
  }).isRequired,
  // from useLocation
  location: shape({
    search: string.isRequired,
  }).isRequired,

  // from useIntl
  intl: intlShape.isRequired,

  // from useConfiguration
  config: object.isRequired,

  // from useRouteConfiguration
  routeConfiguration: arrayOf(propTypes.route).isRequired,
};

const EnhancedSearchPage = props => {
  const config = useConfiguration();
  const routeConfiguration = useRouteConfiguration();
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();

  return (
    <SearchPageComponent
      config={config}
      routeConfiguration={routeConfiguration}
      intl={intl}
      history={history}
      location={location}
      {...props}
    />
  );
};

const mapStateToProps = (state, ownProps) => {
  const stateBranch = ownProps.searchStateBranch || 'SearchPage';
  const {
    listings,
    pagination,
    facetCounts,
    searchInProgress,
    searchListingsError,
    searchParams,
    activeListingId,
  } = state[stateBranch] || {};
  const { currentUser } = state.user;
  const { toggleFavoriteListingId, toggleFavoriteError } = state.WishlistPage;

  return {
    listings,
    pagination,
    facetCounts,
    scrollingDisabled: isScrollingDisabled(state),
    searchInProgress,
    searchListingsError,
    searchListingsError,
    searchParams,
    activeListingId,
    currentUser,
    toggleFavoriteListingId,
    toggleFavoriteError,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onToggleFavorite: listingId => dispatch(toggleFavorite(listingId)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const SearchPage = withCookies(
  compose(connect(mapStateToProps, mapDispatchToProps))(EnhancedSearchPage)
);

export default SearchPage;
